import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';
import { Button } from '@telus-uds/components-web';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import ErrorMessages from './profile';
import { forgotPasswordSchema } from './schema';
import SuccessMessage from './success';
import ValidateLoader from '../UI/validateLoader';
import { apiHost } from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import '../../assets/css/forgotPassword.css';
import '../../assets/css/forgot_media_query.css';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const localizedStrings = useLocalizedStringsContext();

  const forgotPasswordRequest = values => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    const { email, lastName } = values;
    axios
      .post(`${apiHost}/forgotPassword`, { email, lastName })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(err => {
        const {
          data: { error }
        } = err && err.response;
        setError(error);
        setLoading(false);
      })
      .then(() => {
        setLoading(false);
      });
  };
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: {
          FORGOT_PASSWORD_HEADING,
          FORGOT_PASSWORD_TITLE,
          FORGOT_PASSWORD_USERNAME,
          FORGOT_PASSWORD_LASTNAME,
          FORGOT_PASSWORD_PLACEHOLDER_EMAIL,
          FORGOT_PASSWORD_PLACEHOLDER_LAST_LAST,
          FORGOT_PASSWORD_VERIFY_MESSAGE
        },
        BUTTONS_TITLE
      }
    }
  } = localizedStrings;

  return (
    <>
      <div id="main">
        <div id="main-wrapper">
          <div id="main-content">
            <ErrorMessages error={isError} />
            <div id="main-content-steps">
              <span className="frg-body-font-14px">
                {FORGOT_PASSWORD_HEADING}
              </span>
            </div>
            <div id="main-content-indicator">
              <div id="main-content-indicator-step1"></div>
            </div>
            <div id="main-content-login">
              <Formik
                initialValues={{
                  email: '',
                  lastName: ''
                }}
                validationSchema={forgotPasswordSchema}
                onSubmit={values => {
                  forgotPasswordRequest(values);
                }}
              >
                {({ errors, touched, handleSubmit }) => (
                  <Form>
                    <div>
                      <span className="frg-body-font-14px">
                        {FORGOT_PASSWORD_TITLE}
                      </span>
                    </div>

                    {isSuccess && <SuccessMessage />}
                    <div
                      id="username_container"
                      style={{ position: 'relative' }}
                    >
                      <div className="main-content-form-headers">
                        <span className="frg-body-font-14px">
                          {FORGOT_PASSWORD_USERNAME}*
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${
                          errors.email && touched.email ? 'error' : ''
                        }`}
                      >
                        <Field
                          type="email"
                          name="email"
                          style={{ width: '100%' }}
                          className="select-style"
                          placeholder={FORGOT_PASSWORD_PLACEHOLDER_EMAIL}
                        />

                        <>
                          <div className="error_messages">
                            <span className="frg-body-font-14px">
                              {errors.email}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <StatusError size={16} color="#C12335" aria-hidden="true" />
                          </div>
                        </>
                      </div>
                    </div>

                    <div style={{ marginTop: 15, position: 'relative' }}>
                      <div className="main-content-form-headers">
                        <span className="frg-body-font-14px">
                          {FORGOT_PASSWORD_LASTNAME}*
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${
                          errors.lastName && touched.lastName ? 'error' : ''
                        }`}
                      >
                        <Field
                          type="text"
                          name="lastName"
                          style={{ width: '100%' }}
                          className="select-style"
                          placeholder={FORGOT_PASSWORD_PLACEHOLDER_LAST_LAST}
                        />
                        <>
                          <div className="error_messages">
                            <span className="frg-body-font-14px">
                              {errors.lastName}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <StatusError size={16} color="#C12335" aria-hidden="true" />
                          </div>
                        </>
                      </div>
                    </div>
                    {loading && (
                      <ValidateLoader
                        message={FORGOT_PASSWORD_VERIFY_MESSAGE}
                      />
                    )}
                    <div style={{ marginTop: 20, textAlign: 'center' }}>
                      <span>
                        <Button
                          type="submit"
                          variant={{ priority: 'high', size: 'large' }}
                          style={{ width: '100%' }}
                          disabled={isSuccess}
                          onPress={handleSubmit}
                        >
                          {BUTTONS_TITLE.CONTINUE}
                        </Button>
                      </span>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ForgotPassword.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default ForgotPassword;
